module.exports = __webpack_public_path__ + "img/digital02.636a3c3f.png";